const HealthCheck=()=>{
    console.log('status : ok')

    return (
        null
    )
}

export default HealthCheck;